import { render, staticRenderFns } from "./SubprogramElement.vue?vue&type=template&id=76784fa6&scoped=true&"
import script from "./SubprogramElement.vue?vue&type=script&lang=js&"
export * from "./SubprogramElement.vue?vue&type=script&lang=js&"
import style0 from "./SubprogramElement.vue?vue&type=style&index=0&id=76784fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76784fa6",
  null
  
)

export default component.exports